import { render, staticRenderFns } from "./ConsultaBoletins.vue?vue&type=template&id=3d0b541f"
import script from "./ConsultaBoletins.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConsultaBoletins.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports